module.exports = __webpack_public_path__ + "static/media/ipad_rotate.9a0a973a.jpeg";